/**
 * A clip's freshness on its thumbnail (Dax, 2026-10-04): a clock in the colour of how recently it was used,
 * on the duration badge's grey. Meaning picks the clip; the badge lets the person judge its freshness.
 */
import type { ClipFreshness } from '@studio/contracts';
import { Icon } from './icons';

export const FRESHNESS_LABELS: Record<ClipFreshness, string> = {
  new: 'Never used',
  rested: 'Last published over 90 days ago',
  drafts: 'Never published; in other drafts',
  recent90: 'Published in the last 90 days',
  recent60: 'Published in the last 60 days',
  recent30: 'Published in the last 30 days',
};

export function FreshnessBadge({ freshness }: { freshness: ClipFreshness }) {
  return (
    <span className={`slot-fresh fresh-${freshness}`} title={FRESHNESS_LABELS[freshness]} aria-label={FRESHNESS_LABELS[freshness]} role="img">
      <Icon name="clock" />
    </span>
  );
}

/** The same colour as a dot, for a menu entry. */
export function FreshnessDot({ freshness }: { freshness: ClipFreshness }) {
  return <span className={`fresh-dot fresh-${freshness}`} aria-hidden="true" />;
}
